import { ADDTRAVELDETAILS, ADDTRAVELNUMBER, ALLTRAVELDETAILS, TRAVELNUMFLAG } from "../actiontypes/NumTravelActiontypes "

export const numtravelflagfalse=()=>{
    return{
        type:TRAVELNUMFLAG
    }
}
export const alltraveldetails=()=>{
    return{
        type:ALLTRAVELDETAILS
    }
}
export const addtravelnum=(data)=>{
    console.log(data)
    return{
        type:ADDTRAVELNUMBER,
        payload:data
    }
}
export const addtraveldetails=(data)=>{
    return{
        type:ADDTRAVELDETAILS,
        payload:data
    }
}
